import React from 'react';
import { isAnyTags } from '@scale/shared/workerSlack/helpers';

const SlackChannelTags = (props: $FIXME) => {
  return (
    <>
      <div className="item-option-container">
        <label>Tags: </label>
        <div className="tier-statuses-container">
          {!isAnyTags(props.channel.tags) &&
            props.channel.tags.map((tag: { _id?: string; name: string }) => {
              return (
                <div
                  key={tag.name}
                  className={`tier-status-box-container  tier-status-box-${tag.name}`}
                >
                  <div className="tier-status-box">{tag.name}</div>
                </div>
              );
            })}
          {!!isAnyTags(props.channel.tags) && (
            <div className={`tier-status-box-container  tier-status-box-level-${null}`}>
              <div className="tier-status-box">All tags</div>
            </div>
          )}
        </div>
      </div>
      <style>{`
        label {
          font-weight: 500;
          padding-right: 4px;
        }
        .tier-statuses-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 300px;
          margin-left: 8px;
        }
        .tier-status-box-container {
          border-radius: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 4px;
          border: 1px solid var(--color-RemoGray50);
        }
        .tier-status-box {
          padding: 4px 12px;
          white-space: nowrap;
        }
        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}</style>
    </>
  );
};

export default SlackChannelTags;
